import { getIn, useFormikContext } from "formik";
import { sendFile } from "../../../../../common/services/hold-document";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";

type Props = {
  pathToUpload: string;
  name: string;
  className?: string;
  children?: (props: {
    src: string;
    onNewFile: (file: File) => Promise<void>;
    onRemoveClick: () => void;
  }) => React.ReactNode;
}

export const UploadDocumentFieldLeadsFormik: React.FC<Props> = (props: Props) => {
  const { notifySuccess, notifyError } = useToastContext()
  const { values, setFieldValue } = useFormikContext();
  const currentSrc = getIn(values, props.name)

  async function handleNewFile(file) {
    try {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = async function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Define o tamanho do canvas para ser o mesmo que a imagem, mas com metade do tamanho
        canvas.width = img.width / 2;
        canvas.height = img.height / 2;

        // Desenha a imagem no canvas
        if (ctx !== null)
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Converte o canvas de volta para uma imagem
        canvas.toBlob(async function (blob) {
          if (blob === null) {
            notifyError('Falha na conversão da imagem, tente novamente');
            return;
          }
          const compressedFile = new File([blob], 'compressed.jpg', { type: 'image/jpeg', lastModified: Date.now() });

          const prefix = props.pathToUpload;

          const { ok, data, message } = await sendFile({ prefix, file: compressedFile });

          if (!ok) {
            notifyError(message || 'Não foi possível salvar a imagem, tente novamente')
            return
          }

          const [{ key }] = data

          setFieldValue(props.name, key)

          notifySuccess('Imagem salva com sucesso')

          compressedFile.arrayBuffer().then(buffer => {
            new Blob([buffer]);

          })
        }, 'image/jpeg', 0.5);	// 0.5 é a qualidade da imagem
      };
    } catch (err) {
      notifyError((err as { message: string }).message || 'Não foi possível salvar a imagem, tente novamente')
    }
  }

  function handleRemoveFile() {
    setFieldValue(props.name, '')
  }

  return (
    <div className={`flex justify-center items-center ${props.className}`}>
      {props.children && typeof props.children === 'function' &&
        props.children({
          src: currentSrc,
          onNewFile: handleNewFile,
          onRemoveClick: handleRemoveFile,
        })}
    </div>
  )
}
